export const Evaluation360Storage = {
    DASHBOARD: 'dashboard',
    SELECT_REVIEWEE: 'select-reviewee',
} as const;
